import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  totalPrice: 0,
  totalItems: 0,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const newItem = action.payload;

      // Check if item already exists in cart by slug
      const existingItem = state.data.find(
        (item) => item.slug === newItem.slug
      );

      if (existingItem) {
        // Update the price if slug matches
        existingItem.price = newItem.price;
      } else {
        // Add new item to cart
        state.data.push(newItem);
      }

      // Recalculate the total price and total items
      state.totalPrice = state.data.reduce(
        (total, item) => total + parseFloat(item.price),
        0
      );
      state.totalItems = state.data.length;
    },

    removeFromCart: (state, action) => {
      const slugToRemove = action.payload;

      // Remove item by slug
      state.data = state.data.filter((item) => item.slug !== slugToRemove);

      // Recalculate the total price and total items
      state.totalPrice = state.data.reduce(
        (total, item) => total + parseFloat(item.price),
        0
      );
      state.totalItems = state.data.length;
    },

    updateItemPrice: (state, action) => {
      const { slug, price } = action.payload;

      const existingItem = state.data.find((item) => item.slug === slug);

      if (existingItem) {
        existingItem.price = price;

        state.totalPrice = state.data.reduce(
          (total, item) => total + parseFloat(item.price),
          0
        );
      }
    },
    updateTotalItem: (state, action) => {
      state.data = [];
      state.totalPrice = 0;
      state.totalItems = 0;
    },
  },
});

export const { addToCart, removeFromCart, updateItemPrice, updateTotalItem } =
  cartSlice.actions;

export default cartSlice.reducer;
